import { render, staticRenderFns } from "./LoaderApp.vue?vue&type=template&id=8889921a&scoped=true&"
import script from "./LoaderApp.vue?vue&type=script&lang=js&"
export * from "./LoaderApp.vue?vue&type=script&lang=js&"
import style0 from "./LoaderApp.vue?vue&type=style&index=0&id=8889921a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8889921a",
  null
  
)

export default component.exports